import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import PrestaGlobals from '../common/PrestaGlobals';

/** Fixed marker on /designeradmin: which employee, customer and cart this page works on. */
const AdminBadge: React.FC = () => (
    <Box
        sx={{
            position: 'fixed', bottom: 16, left: 16, zIndex: 1100,
            px: 1.5, py: 0.75, borderRadius: 1,
            bgcolor: 'error.main', color: '#fff',
            boxShadow: 3, pointerEvents: 'none', maxWidth: 'calc(100vw - 96px)',
        }}
    >
        <Typography variant="caption" component="div" sx={{ color: 'inherit', fontWeight: 700, lineHeight: 1.3 }} noWrap>
            ADMIN{PrestaGlobals.employeeName ? ` · ${PrestaGlobals.employeeName}` : ''}
        </Typography>
        <Typography variant="caption" component="div" sx={{ color: 'inherit', lineHeight: 1.3 }} noWrap>
            Vásárló: {PrestaGlobals.customerLabel || 'Vendég'} · Kosár #{PrestaGlobals.cartId}
        </Typography>
    </Box>
);

export default AdminBadge;
